module.exports = __webpack_public_path__ + "img/miyagi.b18b0fcc.png";